import {Component, Input, OnInit} from '@angular/core';
import {EvkExpedienteModel} from "../../../../../../expediente/models/evk-expediente.model";
import {EvkExpedienteConfigModel} from "../../../../../../expediente/models/evk-expediente-config.model";

@Component({
    selector: 'lib-diligencia-detalle',
    templateUrl: './diligencia-detalle.component.html',
    styleUrls: ['./diligencia-detalle.component.css']
})
export class DiligenciaDetalleComponent implements OnInit {
    @Input()
    expediente: EvkExpedienteModel;
    @Input()
    expedienteConfig: EvkExpedienteConfigModel;

    constructor(
    ) {
    }

    ngOnInit(): void {
        console.log(this.expediente);
    }

}
